import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
    remainingTime: "00:00",
    remainingTimeInSeconds: 600,
};

const getters = {
	getRemainingTimeInSeconds: (state) => state.remainingTimeInSeconds,
	getRemainingTime: (state) => state.remainingTime,
};

const mutations = {
    updateRemainingTime(state, payload) {
        state.remainingTime = payload;
	},
	updateRemainingTimeInSeconds(state, payload) {
        state.remainingTimeInSeconds = payload - 1;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
